const formatGenderLabel = (value) => {
  if (value == null || value === '') return null;
  const normalized = String(value).trim().toLowerCase();
  if (normalized === 'male') return 'Male';
  if (normalized === 'female') return 'Female';
  return String(value).trim();
};

export const extractJoinRequestsFromPayload = (payload) => {
  const root = payload?.data ?? payload;

  if (Array.isArray(root)) return root;
  if (Array.isArray(root?.joinRequests)) return root.joinRequests;
  if (Array.isArray(root?.requests)) return root.requests;
  if (Array.isArray(root?.data)) return root.data;
  if (Array.isArray(root?.data?.joinRequests)) return root.data.joinRequests;

  return [];
};

export const normalizeJoinRequestItem = (item, index) => {
  if (!item || typeof item !== 'object') return null;

  const requester = item.requester && typeof item.requester === 'object' ? item.requester : item;

  const name = requester.fullName ?? requester.name ?? item.fullName ?? item.name ?? 'Member';
  const compatibilityRaw =
    item.compatibility ??
    item.compatibilityScore ??
    item.matchScore ??
    item.matchPercentage ??
    requester.compatibility ??
    requester.compatibilityScore ??
    null;
  const compatibility =
    compatibilityRaw != null && !Number.isNaN(Number(compatibilityRaw))
      ? Number(compatibilityRaw)
      : null;
  const interestsSource = requester.interests ?? item.interests;

  return {
    id: item.id ?? item.requestId ?? `join-request-${index}`,
    requesterUserId: item.requesterUserId ?? requester.id ?? null,
    channelId: item.channelId ?? null,
    status: item.status ?? 'pending',
    uid: requester.uid ?? item.uid ?? null,
    name,
    fullName: name,
    role: requester.profession ?? requester.role ?? item.profession ?? item.role ?? '',
    avatarUrl: requester.avatarUrl ?? item.avatarUrl ?? undefined,
    gender: formatGenderLabel(requester.gender ?? item.gender),
    email: requester.userEmail ?? requester.email ?? item.userEmail ?? item.email ?? '',
    phone: requester.phoneNumber ?? requester.phone ?? item.phoneNumber ?? item.phone ?? '',
    compatibility,
    profession: requester.profession ?? item.profession ?? item.role ?? '',
    interests: Array.isArray(interestsSource) ? interestsSource.filter(Boolean) : [],
    requester,
    raw: item,
  };
};

export const mapPartnerGroupChannelJoinRequests = (payload) => {
  const requests = extractJoinRequestsFromPayload(payload)
    .map(normalizeJoinRequestItem)
    .filter(Boolean);

  return { requests };
};

export const mapPartnerGroupChannelJoinRequestsResponse = (result) => {
  if (!result || result.status === 'error') {
    return {
      status: 'error',
      requests: [],
      message: result?.message ?? null,
    };
  }

  if (result.status === 'forbidden') {
    return {
      status: 'forbidden',
      requests: [],
      message: result.message ?? null,
    };
  }

  if (result.status === 'not_found') {
    return {
      status: 'found',
      requests: [],
      message: result.message ?? null,
    };
  }

  const mapped = mapPartnerGroupChannelJoinRequests(result.data);

  return {
    status: 'found',
    requests: mapped.requests,
    message: result.message ?? null,
  };
};
